import React, {useState, ReactNode} from 'react';

interface LoginContextType {
    loginType: wts_approved_any;
    setLoginType: (loginType: wts_approved_any) => void;
}

interface LoginProviderProps {
    children: ReactNode;
}

const LoginContext = React.createContext<LoginContextType | null>(null);

export default function LoginProvider({children}: LoginProviderProps) {

    const [loginType, setLoginType] = useState(null);

    return (
        <LoginContext.Provider value={{loginType, setLoginType}}>
            {children}
        </LoginContext.Provider>
    )
}

export function useLogin(): LoginContextType {
    return React.useContext(LoginContext)!
}